import DropdownRenderer from "./dropdown.component.renderer";
import TypeaheadRenderer from "./typeahead.component.renderer";

export default class DropdownComponent extends HTMLElement {

    constructor(config = {}) {
        super();

        this.placeholder = config.placeholder || "";
        this.config = config;
        this.dataset.level = this.config.level;
    }

    disconnectedCallback() {
        if (this.renderer) {
            this.renderer.dispose();
            this.renderer = null;
        }
    }

    setOptions(options, useTypeahead) {

        options = this.config.sortById ? options.sort((a,b) => a.id - b.id) : options.sort((a,b) => a.name.localeCompare(b.name));
        
        const onSelectOption = (selectedOption) => {
            this.dataset.selectedId = selectedOption?.dataset?.id || -1;
            this.dispatchEvent(new CustomEvent("dropdown-change", { bubbles: true }));
        };

        if (useTypeahead) {
            if (this.renderer?.constructor.name === "DropdownRenderer") {
                this.renderer.clear();
            }
            this.renderer = new TypeaheadRenderer(this, onSelectOption);
        }
        else {
            if (this.renderer?.constructor.name === "TypeaheadRenderer") {
                this.renderer.clear();
            }
            this.renderer = new DropdownRenderer(this, onSelectOption);
        }

        this.renderer.render(this.parseOptions(options));
    }

    parseOptions(dropdownOptions) {
        let optionsHtml = "";

        dropdownOptions.forEach((option, index) => {
            optionsHtml += `<option data-index="${index + 1}" data-id="${option.id}" value="${option.name}">${option.name}</option>`;
        });
        return optionsHtml;
    }


    setCurrentIndex(index) {
        this.renderer?.setCurrentIndex(index);
    }

    setSelectedId(id) {
        this.renderer?.setSelectedId(id);
    }

}
